import "./App.css";
import { Link } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";


function MyButton() {
  return (
    <Link to="/Questions">
      <button className="main-button">Get Started</button>
    </Link>
  );
}

export default function MyApp() {
  return (
    <div className="content">
      <h1>Confused which UX method will go with your product?</h1>
      <MyButton />
      <Analytics />
    </div>
  );
}
